module.exports = __webpack_public_path__ + "static/20190602_170904_optimized-df66f050a7c1ad53b05d20c06001df29.jpg";